import { SxProps, Theme } from "@mui/material";
import { merge } from "lodash";
import { ElementType, ReactElement } from "react";
import { Button, ButtonProps } from "../../Inputs/Button/Button";

const sizeToSx: Record<NonNullable<ButtonProps["size"]>, SxProps<Theme>> = {
  small: { minWidth: "30px", height: "30px" },
  medium: { minWidth: "36px", height: "36px" },
  large: { px: 2, minWidth: "40px", height: "40px" },
  xlarge: { px: 2, minWidth: "40px", height: "40px" },
};

export const MediaTileButton = <C extends ElementType = "button">({
  className,
  size,
  sx,
  children,
  ...props
}: ButtonProps<C>): ReactElement => (
  // @ts-expect-error FIXME
  <Button
    {...props}
    size="medium"
    className={["MuiMediaTileButton-root", className].filter(Boolean).join(" ")}
    sx={merge(
      {},
      {
        px: 1,
        color: "grey.600",
        backgroundColor: "grey.200",
        boxShadow: 3,
        "&:hover": {
          color: "primary.main",
          backgroundColor: "grey.50",
          boxShadow: 3,
        },
      },
      sizeToSx[size || "medium"] || sizeToSx.medium,
      sx,
    )}
  >
    {children}
  </Button>
);
